import { createCategoryHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/CategoryHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';

export const useCategory = (id: string) => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['category', id, user?.token],
    queryFn: async () => {
      if (!user?.token) throw new Error('User not authenticated');
      if (!id) throw new Error('Category ID is required');

      const tokenProvider = { getToken: async () => user.token };
      const repository = createCategoryHttpRepository(tokenProvider);

      return await repository.findById(id);
    },
    enabled: !!user?.token && !!id,
    staleTime: 1000 * 60 * 5,
  });
};
